import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

function ProjectsShowcase() {
  const { t } = useTranslation("homepage");
  const projects = t("projectsShowcase.projects", { returnObjects: true });
  
  // Project URLs mapping to project pages - All six main projects
  const projectUrls = {
    "ONEART RESIDENCE": "/projects/bellemare",
    "ONEART GARDENS": "/projects/garden",
    "ONEART PLAZA": "/projects/fifthelement",
    "ONEART VISTA": "/projects/prestigepark",
    "ONEART HAVEN": "/projects/theframe",
    "ONEART LUXE": "/projects/bellemare",
    "ONEART SUITES": "/projects/botanicheska302",
    "ONEART ESTATE": "/projects/garden",
    "ONEART PREMIUM": "/projects/fifthelement"
  };
  
  // Duplicate projects to create infinite loop effect
  const duplicatedProjects = [...projects, ...projects, ...projects];
  
  // Split into two rows (5 projects each)
  const firstRowProjects = duplicatedProjects.slice(0, 5);
  const secondRowProjects = duplicatedProjects.slice(5, 10);
  
  const [firstRowIndex, setFirstRowIndex] = useState(0);
  const [secondRowIndex, setSecondRowIndex] = useState(0);

  useEffect(() => {
    // Faster intervals for mobile
    const isMobile = window.innerWidth <= 768;
    const firstRowSpeed = isMobile ? 2000 : 3000;
    const secondRowSpeed = isMobile ? 2500 : 3500;

    const firstRowInterval = setInterval(() => {
      setFirstRowIndex(prev => (prev + 1) % projects.length);
    }, firstRowSpeed);

    const secondRowInterval = setInterval(() => {
      setSecondRowIndex(prev => (prev + 1) % projects.length);
    }, secondRowSpeed);

    return () => {
      clearInterval(firstRowInterval);
      clearInterval(secondRowInterval);
    };
  }, [projects.length]);

  return (
    <>
      <style jsx>{`
        .carousel-container {
          -webkit-overflow-scrolling: touch;
          scroll-behavior: smooth;
          touch-action: pan-x;
        }
        
        .carousel-container::-webkit-scrollbar {
          display: none;
        }
        
        .project-card-link {
          text-decoration: none;
          color: inherit;
          display: block;
        }
        
        @media (max-width: 991px) {
          .tc-projects-showcase {
            padding: 50px 0 !important;
          }
          
          .projects-title {
            font-size: 2.5rem !important;
            margin-bottom: 15px !important;
          }
          
          .projects-description {
            font-size: 1rem !important;
            padding: 0 20px !important;
          }
          
          .projects-carousel {
            margin-top: 30px !important;
          }
        }
        
        @media (max-width: 768px) {
          .tc-projects-showcase {
            padding: 40px 0 !important;
          }
          
          .projects-title {
            font-size: 2rem !important;
            margin-bottom: 15px !important;
            line-height: 1.2 !important;
          }
          
          .projects-description {
            font-size: 0.9rem !important;
            padding: 0 20px !important;
            line-height: 1.5 !important;
          }
          
          .carousel-container {
            padding: 0 10px;
            margin: 0 -10px;
          }
          
          .carousel-slide {
            min-width: 200px !important;
            margin-right: 12px !important;
            width: 200px !important;
            max-width: 200px !important;
          }
          
          .project-card {
            width: 100% !important;
            height: 220px !important;
            border-radius: 8px !important;
          }
          
          .project-image {
            height: 220px !important;
            width: 100% !important;
          }
          
          .btn-see-all {
            padding: 10px 24px !important;
            font-size: 0.85rem !important;
            margin-top: 20px !important;
          }
          
          .carousel-row {
            margin-bottom: 20px !important;
          }
          
          .projects-cta {
            margin-top: 40px !important;
            padding: 0 20px !important;
          }
        }
        
        @media (max-width: 480px) {
          .tc-projects-showcase {
            padding: 30px 0 !important;
          }
          
          .projects-title {
            font-size: 1.75rem !important;
            margin-bottom: 12px !important;
            padding: 0 15px !important;
          }
          
          .projects-description {
            font-size: 0.85rem !important;
            padding: 0 15px !important;
            line-height: 1.4 !important;
          }
          
          .carousel-container {
            padding: 0 8px;
            margin: 0 -8px;
          }
          
          .carousel-slide {
            min-width: 170px !important;
            margin-right: 10px !important;
            width: 170px !important;
            max-width: 170px !important;
          }
          
          .project-card {
            width: 100% !important;
            height: 200px !important;
            border-radius: 6px !important;
          }
          
          .project-image {
            height: 200px !important;
            width: 100% !important;
          }
          
          .btn-see-all {
            padding: 8px 20px !important;
            font-size: 0.8rem !important;
            margin-top: 15px !important;
          }
          
          .carousel-row {
            margin-bottom: 15px !important;
          }
          
          .projects-cta {
            margin-top: 30px !important;
            padding: 0 15px !important;
          }
        }
        
        @media (max-width: 360px) {
          .carousel-slide {
            min-width: 150px !important;
            margin-right: 8px !important;
            width: 150px !important;
            max-width: 150px !important;
          }
          
          .project-card {
            height: 180px !important;
          }
          
          .project-image {
            height: 180px !important;
          }
        }
      `}</style>
      <section className="tc-projects-showcase azizi-projects" style={{ 
        backgroundColor: '#ffffff', 
        padding: '80px 0' 
      }}>
        <div className="container">
          <div className="projects-header text-center">
            <h1 className="projects-title" style={{ 
              color: 'rgb(73, 69, 56)', 
              fontSize: '3rem', 
              fontWeight: '600', 
              marginBottom: '20px' 
            }}>
              {t("projectsShowcase.title")}
            </h1>
            <p className="projects-description" style={{ 
              color: '#666', 
              fontSize: '1.1rem', 
              maxWidth: '600px', 
              margin: '0 auto'
            }}>
              {t("projectsShowcase.description")}
            </p>
          </div>
        
        <div className="projects-carousel" style={{ 
          marginTop: '50px' 
        }}>
          {/* First Row Carousel */}
          <div className="carousel-row" style={{ 
            marginBottom: '30px' 
          }}>
            <div className="carousel-container" style={{
              display: 'flex',
              overflowX: 'auto',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              WebkitOverflowScrolling: 'touch',
              scrollBehavior: 'smooth'
            }}>
              {firstRowProjects.map((project, index) => (
                <div key={`first-${index}`} className="carousel-slide" style={{
                  minWidth: '300px',
                  marginRight: '20px',
                  flexShrink: 0
                }}>
                  <a href={projectUrls[project.name] || "/innerpages/portfolio"} className="project-card-link">
                    <div className="project-card" style={{ 
                      borderRadius: '10px', 
                      overflow: 'hidden',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                      transition: 'all 0.3s ease',
                      border: '2px solid transparent'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 15px 35px rgba(73, 69, 56, 0.3)';
                      e.currentTarget.style.borderColor = 'rgb(73, 69, 56)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                      e.currentTarget.style.borderColor = 'transparent';
                    }}>
                      <div className="project-image" style={{ position: 'relative', overflow: 'hidden' }}>
                        <img
                          src={project.image}
                          alt={project.name}
                          className="img-cover"
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          
          {/* Second Row Carousel */}
          <div className="carousel-row">
            <div className="carousel-container" style={{
              display: 'flex',
              overflowX: 'auto',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              WebkitOverflowScrolling: 'touch',
              scrollBehavior: 'smooth'
            }}>
              {secondRowProjects.map((project, index) => (
                <div key={`second-${index}`} className="carousel-slide" style={{
                  minWidth: '300px',
                  marginRight: '20px',
                  flexShrink: 0
                }}>
                  <a href={projectUrls[project.name] || "/innerpages/portfolio"} className="project-card-link">
                    <div className="project-card" style={{ 
                      borderRadius: '10px', 
                      overflow: 'hidden',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                      transition: 'all 0.3s ease',
                      border: '2px solid transparent'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 15px 35px rgba(73, 69, 56, 0.3)';
                      e.currentTarget.style.borderColor = 'rgb(73, 69, 56)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                      e.currentTarget.style.borderColor = 'transparent';
                    }}>
                      <div className="project-image" style={{ position: 'relative', overflow: 'hidden' }}>
                        <img
                          src={project.image}
                          alt={project.name}
                          className="img-cover"
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="projects-cta text-center" style={{ 
          marginTop: '60px' 
        }}>
          <a 
            href="/innerpages/portfolio" 
            className="btn-see-all"
            style={{
              backgroundColor: 'rgb(73, 69, 56)',
              color: '#ffffff',
              padding: '10px 25px',
              borderRadius: '5px',
              textDecoration: 'none',
              fontSize: '0.9rem',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              transition: 'all 0.3s ease',
              display: 'inline-block',
              border: '2px solid rgb(73, 69, 56)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#ffffff';
              e.target.style.color = 'rgb(73, 69, 56)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgb(73, 69, 56)';
              e.target.style.color = '#ffffff';
            }}
          >
            {t("projectsShowcase.seeAllButton")}
          </a>
        </div>
      </div>
    </section>
    </>
  );
}

export default ProjectsShowcase;
